import React, { useEffect, useState } from "react";
import Navbar from "./components/Navbar/Navbar";
import Hero from "./components/Hero/Hero";
import Footer from "./components/Footer/Footer";
import { hooks as mHooks } from "./wallet/metamask";
import { hooks as wHooks } from "./wallet/walletconnect";
import Error from "./components/Error/Error";
import Modal from "./components/Navbar/Modal/Modal";
import AppContext from "./AppContext";
import Popup from "./components/Popup";

const App = () => {
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [walletChoice, setWalletChoice] = useState("");
	const [manualError, setManualError] = useState("");
	const [fundsError, setFundsError] = useState("");
	const [deniedError, setDeniedError] = useState("");
	const [isPopupOpen, setIsPopupOpen] = useState(false);

	useEffect(() => {
		setIsPopupOpen(true);
	}, []);

	useEffect(() => {
		if (localStorage.getItem("wallet")) {
			setWalletChoice(localStorage.getItem("wallet"));
		}
	}, []);

	const { useError, useChainId, useIsActive } =
		walletChoice === "metamask" ? mHooks : walletChoice === "walletconnect" ? wHooks : mHooks;

	const error = useError();
	const chainId = useChainId();
	const isActive = useIsActive();
	const state = {
		walletChoice,
		setManualError,
		setFundsError,
		setDeniedError,
	};

	useEffect(() => {
		error && error.message === "User closed modal" && window.location.reload();
	}, [error]);

	useEffect(() => {
		if (manualError) {
			setTimeout(() => {
				setManualError("");
			}, 4000);
		}
	}, [manualError]);

	useEffect(() => {
		if (deniedError) {
			setTimeout(() => {
				setDeniedError("");
			}, 4000);
		}
	}, [deniedError]);

	useEffect(() => {
		if (fundsError) {
			setTimeout(() => {
				setFundsError("");
			}, 4000);
		}
	}, [fundsError]);

	useEffect(() => {
		localStorage.setItem("wallet", walletChoice);
	}, [walletChoice]);

	return (
		<AppContext.Provider value={state}>
			<div className="relative flex place-items-center font-primary transition-all ">
				{isPopupOpen && (
					<div className="bg-black">
						<Popup setIsPopupOpen={setIsPopupOpen} />
					</div>
				)}
				<div
					className={`${
						isPopupOpen && "opacity-25 pointer-events-none"
					} text-xl xl:text-2xl 2xl:text-3xl bg-gradient-to-br from-purple to-skyBlue min-h-screen flex flex-col items-center select-none relative overflow-x-hidden`}>
					{((walletChoice && error) || manualError || fundsError || deniedError) && (
						<Error
							error={error}
							chainId={chainId}
							isActive={isActive}
							manualError={manualError}
							fundsError={fundsError}
							deniedError={deniedError}
						/>
					)}
					{isModalOpen && (
						<Modal
							setWalletChoice={setWalletChoice}
							isModalOpen={isModalOpen}
							setIsModalOpen={setIsModalOpen}
						/>
					)}
					<div
						className={`${isModalOpen ? "opacity-30" : "flex flex-col items-center"}`}
						style={isModalOpen ? { pointerEvents: "none" } : {}}>
						<Navbar
							setIsModalOpen={setIsModalOpen}
							isModalOpen={isModalOpen}
							walletChoice={walletChoice}
							setWalletChoice={setWalletChoice}
						/>
						<Hero />
						<Footer />
					</div>
				</div>
			</div>
		</AppContext.Provider>
	);
};

export default App;
